import React from 'react'
import PropTypes from 'prop-types'

import Box from '@material-ui/core/Box'

import HotkeyNavigationButton from './HotkeyNavigationButton'

import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  main: {
    backgroundColor: '#f8f8fa',
    width: 516 // this value is key to the grid working so be very careful changing it!!! - it needs to be the sum of 12 * elementWidth (currently 43)
  }
})

export default function HotkeyNavigationBar (props) {
  const {
    selectedMenu,
    selectedSubMenu,
    onHomeClick,
    onMenuClick
  } = props

  const classes = useStyles()

  return (
    <>
      <Box id="hotkeyNavigationBar" display="flex" className={classes.main}>
        <HotkeyNavigationButton
          text="Home"
          icon="AllCategories"
          onClick={(event) => onHomeClick(event)}
          selected={selectedMenu === null && selectedSubMenu === null} />
        {
          selectedMenu &&
          <HotkeyNavigationButton
            id={selectedMenu.id}
            text={selectedMenu.text}
            icon={selectedMenu.icon}
            onClick={(event) => onMenuClick(event, selectedMenu)}
            selected={selectedSubMenu === null}
          />
        }
        {
          selectedSubMenu &&
          <HotkeyNavigationButton
            id={selectedSubMenu.id}
            text={selectedSubMenu.text}
            icon="NoChosenCategory"
            selected={selectedSubMenu !== null}
          />
        }
      </Box>
    </>
  )
}

HotkeyNavigationBar.propTypes = {
  selectedMenu: PropTypes.object,
  selectedSubMenu: PropTypes.object,
  onMenuClick: PropTypes.func.isRequired,
  onHomeClick: PropTypes.func.isRequired
}
